import type { User } from "@supabase/supabase-js";
import { useAuth } from "./auth-provider";

/**
 * RequireAuth 안쪽 화면용: 로그인한 사용자를 항상 값으로 돌려준다. 문지기가 비로그인을 이미
 * 걸러서 여기서 user가 없다는 건 라우팅 설정이 잘못됐다는 뜻이라, 조용히 넘어가지 않고 던진다.
 */
export function useRequiredUser(): User {
  const { user } = useAuth();
  if (!user) throw new Error("로그인이 필요한 화면에서 사용자 정보를 읽지 못했습니다.");
  return user;
}
